class NewsletterSignup extends window.BAO.CustomElement({
  SuperClass: HTMLElement,
}) {
  static get requiredElements () {
    return ['modal', 'close', 'form']
  }

  static get requiredAttributes () {
    return ['data-animation-delay']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.storageState === 'subscriber') return

    if (
      this.customerPosted === 'true' &&
      window.location.hash.includes(this.formEl?.id)
    ) {
      this.isVisible = true
      this.storageState = 'subscriber'
    }

    /*
     * Show the modal when the customer is not a subscriber and
     * they have not closed it during the current session
     */
    if (this.storageState !== 'closed') {
      /* Show after 4 seconds */
      setTimeout(() => {
        this.isVisible = true
      }, this.animationDelay)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  handleClick (event) {
    if (event.target.closest(this.els?.close?.selector)) {
      this.isVisible = false
      this.storageState = 'closed'
    }
  }

  get formEl () {
    return this.els?.form?.element
  }

  get animationDelay () {
    /* Default delay of 4 seconds */
    const defaultAnimationDelay = 4000
    const animationDelay = Number(this?.dataset?.animationDelay)
    return animationDelay > 0 ? animationDelay * 1000 : defaultAnimationDelay
  }

  get searchParams () {
    return new URLSearchParams(window.location.search)
  }

  get isVisible () {
    return this._isVisible
  }

  set isVisible (boolean) {
    this._isVisible = boolean
    this.els.modal?.element?.setAttribute('aria-hidden', String(!boolean))
  }

  set storageState (string) {
    const now = new Date()
    const item = {
      value: string,
      expiry: now.getTime() + this.storageExpiryInMilliseconds,
    }
    localStorage.setItem(this.storageKey, JSON.stringify(item))
  }

  /**
   * @returns {string} The stored state
   */
  get storageState () {
    const itemString = localStorage.getItem(this.storageKey)
    if (!itemString) {
      return null
    }
    const item = JSON.parse(itemString)
    const now = new Date()
    if (now.getTime() > item.expiry && item.value !== 'subscriber') {
      localStorage.removeItem(this.storageKey)
      return null
    }
    return item.value
  }

  /**
   * @returns {number} The length of time the newsletter modal should remain hidden, in days
   */
  get storageExpiry () {
    /* Default expiry of 28 days */
    const defaultExpiryDays = 28
    const expiryDays = Number(this.getAttribute('data-expiry'))
    return expiryDays > 0 ? expiryDays : defaultExpiryDays
  }

  /**
   * @returns {number} The length of time the newsletter modal should remain hidden, in milliseconds
   */
  get storageExpiryInMilliseconds () {
    return this.storageExpiry * 24 * 60 * 60 * 1000
  }

  get customerPosted () {
    const queryParams = new URLSearchParams(window.location.search)

    return queryParams.get('customer_posted')
  }

  get storageKey () {
    return 'BAO-newsletter-signup'
  }
}

if (!customElements.get('newsletter-signup')) {
  customElements.define('newsletter-signup', NewsletterSignup, {
    extends: 'section',
  })
}
